var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-wrap"},[_c('svg',{staticClass:"loading",attrs:{"width":"44px","height":"44px","viewBox":"0 0 44 44"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"4","stroke-linecap":"round","cx":"22","cy":"22","r":"20"}})]),_vm._v(" "),_c('div',[_vm._v("加载中...")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf18e002","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = null
// module chunks = 